import { model, Model, prop, modelAction } from "mobx-keystone";
import { ApiTokenInfo } from "../helpers/types";

const LSC_HOST = "lightning-swap.com";

@model("lightningswap/ApiToken")
export class ApiToken extends Model({
  uuid:       prop<string>(),
  label:      prop<string>(),
  publicKey:  prop<string>(),
  secret:     prop<string>(),
  lastUsedAt: prop<string | null>(null),
  revokedAt:  prop<string | null>(null)
}) {
  static fromInfo(data: ApiTokenInfo): ApiToken {
    return new ApiToken({
      uuid:       data.uuid,
      label:      data.label,
      publicKey:  data.public_key,
      secret:     data.secret,
      lastUsedAt: data.last_used_at,
      revokedAt:  data.revoked_at
    });
  }

  @modelAction
  revoke = () => {
    this.revokedAt = new Date().toISOString();
  };

  get isActive(): boolean {
    return !this.revokedAt;
  }

  get lscUri(): string {
    const params = new URLSearchParams({ key: this.publicKey, secret: this.secret });
    return `lightning+swapconnect://${LSC_HOST}?${params.toString()}`;
  }
}
